/* eslint-disable import/first */

import 'babel-polyfill';
import 'whatwg-fetch';
import 'firebase';
import 'moment';
import 'moment-duration-format';
import 'moment-timezone/builds/moment-timezone-with-data';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/from';
import 'rxjs/add/operator/shareReplay';
import {setObservableConfig} from 'recompose';
import './_libs/rx-firebase';
// Globals until libraries properly import stuff
import {WEB_BUILD} from './config/constants';
import ngRedux from './_libs/ng-redux';
import uiRouter from 'angular-ui-router';
import ngReduxUiRouter from 'redux-ui-router';

import 'angular-animate';
import 'angular-cookies';
import 'angular-bluebird-promises';
import 'angular-filter';
import 'angular-messages';
import 'rxjs'; // load everything for now... Need to update rx-angular to be selective
import 'rx-angular';
import 'angular-sanitize';
import 'angular-translate';
import 'angular-translate-interpolation-messageformat';
import 'angular-translate-loader-static-files';
import 'angularfire';
import 'angularjs-slider';
import 'ng-cordova';
import './_libs/ngReact';
import 'bluebird';
import './_libs/EventBus/dist/js/EventBus';

import './_libs/ionic/ionic';
import './_libs/ionic/ionic-angular';
import {config as angularTranslateReduxConfig} from './_libs/angular-translate-redux';
// ionic-platform-web-client
import './_libs/ionic-platform-web-client/core/es5';
import './_libs/ionic-platform-web-client/core/angular';
import './_libs/ionic-platform-web-client/push/es5';
import './_libs/ionic-platform-web-client/push/angular';

import 'filepicker-js';

import {configModule} from './config';

// Polyfills
window.Promise = require('bluebird');

setObservableConfig({
  fromESObservable: o => Observable.from(o).shareReplay(1),
});


// We want tree shaking to kill this if possible
if (process.env.BUILD_TARGET === WEB_BUILD) {
  window.OT = require('@opentok/client');
} // otherwise, the cordova plugin will do this.

const angular = require('angular');

/**
 * Legacy App Module Definition
 */
module.exports = angular.module('app', [
  /* components and dependencies */
  require('./_libs/persistent-cache').name,
  'eventBus',
  require('./_libs/angular-fire-util').name,
  require('./_libs/firebase-mq').name,
  require('./_libs/angular-domain').name,
  uiRouter,

  /* Ionic */
  'ionic',
  'ionic.service.core',
  'ionic.service.push',
  /* 'ionic.service.analytics',*/

  /* React */
  'react',

  /* 3rd party components and dependencies */
  ngRedux,
  ngReduxUiRouter,
  'ngAnimate',
  'ngCookies',
  'ngCordova',
  'ngMessages',
  'pascalprecht.translate',
  'rx',
  'angular.filter',
  'mwl.bluebird',
  'rzModule',
  angularTranslateReduxConfig(angular).name,

  /* app configuration */
  require('./core-utilities/app-bootstrap').name,
  configModule.name,

  /* core utilities */
  require('./core-utilities').name,
  require('./core-utilities-implementation').name,
  require('./core-components').name,
  require('./core-components-implementation').name,
  require('./components').name,

  require('./activity-feed').name,
  require('./app').name,
  require('./app-model').name,
  require('./assets').name,
  require('./auth').name,
  require('./calendar').name,
  require('./comments').name,
  require('./data-tags').name,
  require('./domain-directives').name,
  require('./files').name,
  require('./forms').name,
  require('./organizations').name,
  require('./personnel').name,
  require('./priorities').name,
  require('./projects').name,
  require('./requirements').name,
  require('./settings').name,
  require('./system').name,
  require('./tasks').name,
  require('./timers').name,
  require('./todo-messages').name,
  require('./user').name,
  require('./user-profile').name,

]);



// WEBPACK FOOTER //
// ./src/js/module.js